<div class="creditros-portal lp-alert-wrapper d-flex align-items-center" [ngStyle]="{'background-image':'url(../../../../../assets/images/background-images/'+backgroundImageName+')'}">

  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-12">
        <div class="img-parent">
          <img src="./../assets/images/logo.png" alt="logo">
        </div>
        <h1>{{labelCaption['Creditors_Central_Portal']}}</h1>
        <div class="lp-notice">
          <p>{{labelCaption['Ex_KPMGNotice']}}</p>
        </div>
      </div>
      <div class="col-lg-7 col-md-12" *ngIf="!maintenanceDetail?.isMaintenanceInProgress && isServerDataLoaded && (!isServerUnavailable)">
        <div class="row">
          <div *ngIf="maintenanceDetail?.showPriorMessage" class="lp-notice variant-1">
            <p><span>{{labelCaption['Important_Maintenance_Notice']}}</span> {{maintenanceDetail?.priorMessage}}</p>           
          </div>
          <div class="col-12 col-md-6">
            <div class="card core-palette-3">
              <div class="card-body pointer" (click)="show()">
                <div class="d-flex flex-row align-items-end hght100">
                  <h2><a>{{labelCaption['Ex_Login']}}</a></h2>
                </div>
              </div>

            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="card core-palette-4">
              <div class="card-body pointer" (click)="redirectToRegistrationGuideline()">
                <div class="d-flex flex-row align-items-end hght100">
                  <h2><a>{{labelCaption['New_Reg']}}</a></h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="lp-alert variant-1" *ngIf="isServerUnavailable">
        <div class="alert-fig">
          <img class="downtime-icon" src="./../assets/images/downtime_icon.svg" alt="icon">
        </div>
        <div class="alert-content">
          <div class="warning-img">
            <img src="./../assets/images/caution_icon.svg" alt="icon">
          </div>
          <div class="content-info">
            <h3>{{siteDownLabels?.labelOne}}</h3>
            <p>{{siteDownLabels?.labelTwo}}</p>
            <p>{{siteDownLabels?.labelThree}}</p>
          </div>       
        </div>
          <!-- <div class="col-12 lp-notice">
            <img class="caution-icon" src="./../assets/images/caution_icon.svg" alt="icon">
            <h1>{{siteDownLabels?.labelOne}}</h1>
            <p>{{siteDownLabels?.labelTwo}}</p>
            <div class="alert-fig">
              <img class="downtime-icon" src="./../assets/images/downtime_icon.svg" alt="icon">
            </div>
          </div> -->
      </div>
    </div>
  </div>
  <div class="lp-alert" *ngIf="maintenanceDetail?.isMaintenanceInProgress && isServerDataLoaded && (!isServerUnavailable)">
    <div class="alert-fig">
      <img class="downtime-icon" src="./../assets/images/downtime_icon.svg" alt="icon">
    </div>
    <div class="alert-content">
      <div class="content-info">
        <h3>{{labelCaption['Temporarily_Down_Maintenance']}}</h3>
        <p>{{labelCaption['Temporarily_Down_Maintenance_label1']}}</p>
        <p>{{labelCaption['Temporarily_Down_Maintenance_label2']}}</p>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'"  *ngIf="!showTermsAndConditionPage">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header p-4">
        <h4 class="modal-title m-0" id="myModalLabel">Login</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
      </div>
      <div class="modal-body p-4">
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label class="form-label">Email</label>
            <input type="text" formControlName="email" class="form-control" [(ngModel)]="userAccount.emailAddress" (keyup)="onKeyForEmail()" [ngClass]="{ 'is-invalid': (submitted && f.email.errors)|| showEmailIdNotExistAlert }" />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">{{alertMessage['EmailId_Required']}}</div>
              <div *ngIf="f.email.errors.email">{{alertMessage['EmailId_Invalid']}}</div>
            </div>
            <div *ngIf="showEmailIdNotExistAlert" class="invalid-feedback">{{alertMessage['EmailId_Not_Exists']}}</div>
          </div>
          <div class="row mb-3">
            <div class="col-12 text-right">
              <button type="submit" class="primary-button">Go</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

